import React from 'react';

import { getInitials, getRandomColor } from '../../../_helpers';
import styled from '@emotion/styled';
import { Fragment } from 'react';
import ArchivedUser from '../../../assets/archivedUser.svg';
import { Image } from 'react-bootstrap';

const AvatarStyled = styled('div')`
    height: ${(props) => (props.size === 'small' ? '24px' : '40px')};
    width: ${(props) => (props.size === 'small' ? '24px' : '40px')};
    border-radius: ${(props) => (props.size === 'small' ? '12px' : '20px')};
    .initials {
        height: ${(props) => (props.size === 'small' ? '24px' : '40px')};
        width: ${(props) => (props.size === 'small' ? '24px' : '40px')};
        border-radius: ${(props) => (props.size === 'small' ? '12px' : '20px')};
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: ${(props) => (props.size === 'small' ? '10px' : '18px')};
        color: white;
    }
    .avatar {
        height: ${(props) => (props.size === 'small' ? '24px' : '40px')};
        width: ${(props) => (props.size === 'small' ? '24px' : '40px')};
        border-radius: ${(props) => (props.size === 'small' ? '12px' : '20px')};
    }
`;

const Avatar = ({ item, size }) => {
    return (
        <AvatarStyled title={item?.name || ''} size={size}>
            {item ? (
                <Fragment>
                    {item?.avatar ? (
                        <Image src={item.avatar} className="avatar" width="100"></Image>
                    ) : (
                        <div className="initials" style={{ background: getRandomColor(item?.id || item?._id) }}>
                            <span className="text-white">{getInitials(item?.name || item?.username)}</span>
                        </div>
                    )}
                </Fragment>
            ) : (
                <Fragment>
                    <img src={ArchivedUser} className="avatar" alt="deletedUser" />
                </Fragment>
            )}
        </AvatarStyled>
    );
};

export default Avatar;
